// extracted by mini-css-extract-plugin
export default {"bold":"public-iap-reporting-content-Reviews__bold--2OE23"};